import { SERVICE } from '@src/constants';
import api from './api';

export const statApps = async (params) => {
  const res = await api({
    method: 'GET',
    url: `/admin/stats/stat-apps`,
    params,
    source: SERVICE.API_MANAGEMENT,
  });
  return res;
};

export const statUsers = async (params) => {
  const res = await api({
    method: 'GET',
    url: `/admin/stats/stat-users`,
    params,
    source: SERVICE.API_MANAGEMENT,
  });
  return res;
};

export const statPackages = async (params) => {
  const res = await api({
    method: 'GET',
    url: `/admin/stats/stat-packages`,
    params,
    source: SERVICE.API_MANAGEMENT,
  });
  return res;
};
